import { createActionConst } from '../../../utils/action.utils';

const KPI_ROW_NAMESPACE = 'KPI_ROW_NAMESPACE';

export const STORE_KPI_ROW = createActionConst(KPI_ROW_NAMESPACE, 'STORE_KPI_ROW');
export const CLEAR_KPI_ROW = createActionConst(KPI_ROW_NAMESPACE, 'CLEAR_KPI_ROW');
